module.exports = __webpack_public_path__ + "img/laptop.e98372f3.jpg";